import { FC, lazy, Suspense, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { APP_URL } from 'shared/constants/common';

import FormSuccessPudzianImg from 'assets/images/pudzian.webp';
import CheckMarkIcon from './CheckMarkIcon.svg?react';
import './styles.scss';

const Player = lazy(() => import('@lottiefiles/react-lottie-player').then((module) => ({ default: module.Player })));

interface Props {
	text: string;
	closeDialog?: () => void;
	showSuccessConfetti?: boolean | undefined;
}

const FormSuccessDialog: FC<Props> = ({ text, closeDialog, showSuccessConfetti = false }) => {
	const history = useHistory();

	useEffect(() => {
		setTimeout(() => {
			history.push(APP_URL.home);
			closeDialog?.();
			return;
		}, 4000);
	}, [closeDialog, history]);

	return (
		<div className="FormSuccessDialog">
			<div className="FormSuccessDialog__content">
				<CheckMarkIcon className="FormSuccessDialog__icon" />
				<p className="FormSuccessDialog__text">{text}</p>
			</div>
			{showSuccessConfetti && (
				<div className="FormSuccessDialog__animation">
					<Suspense fallback={<></>}>
						<Player src="https://storage.betfan.pl/static/animations/successConfettiAnimation.json" autoplay loop />
					</Suspense>
				</div>
			)}
			<img src={FormSuccessPudzianImg} className="FormSuccessDialog__img" alt="" />
		</div>
	);
};

export default FormSuccessDialog;
